import { render, staticRenderFns } from "./CollectionPicker.vue?vue&type=template&id=0bee748a&scoped=true&"
import script from "./CollectionPicker.vue?vue&type=script&lang=js&"
export * from "./CollectionPicker.vue?vue&type=script&lang=js&"
import style0 from "./CollectionPicker.vue?vue&type=style&index=0&id=0bee748a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bee748a",
  null
  
)

export default component.exports